import React from 'react'
import './field.scss'

const SearchAddressInput = ({
    labelName,
    placeholderName,
    value, 
    onChange,
    disabled
}) => {
    return (
        <>
            <div className="col-sm-6 mt-2 mt-sm-0" style={{ width: '100%', marginBottom: '10px' }}>

                <label className="mb-1"><strong>{labelName}</strong></label>
                <div className='d-flex align-items-center justify-content-center'>
                    <input
                        type="text"
                        className="form-control search-field"
                        placeholder={placeholderName}
                        onChange={onChange}
                        value={value}
                        disabled={disabled}
                        style={{fontSize:'12px', color: !disabled ? 'black' : '' }}
                    />

                    <div class="input-group-prepend">
                        <div className="input-group-text search-icon">
                            <i className="bi bi-geo-alt"></i>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default SearchAddressInput